import Glide from '@glidejs/glide'


const initHomeHeroGlide = () => {
    let block = document.querySelector(".js-home-hero");

    if (!block) return;
    let gliderRoot = block.querySelector(".glide");
    if (!gliderRoot) return;


    const faces = block.querySelectorAll(".js-face")
    const texts = block.querySelectorAll(".js-text")
    const mobileTexts = block.querySelectorAll(".js-mobile-text")

    const updateTexts = (texts, desiredState) => {
        if (!texts) return;
        if (texts.length < 1) return;
        texts.forEach((element, index) => {
            if (index === desiredState) {
                element.animate({ opacity: 1 }, { duration: 300 }).onfinish = () => {
                    element.classList.remove("opacity-0");
                    element.classList.add("z-10");
                };
            } else {
                if (element.classList.contains("opacity-0")) return;
                element.animate({ opacity: 0 }, { duration: 500 }).onfinish = () => {
                    element.classList.add("opacity-0");
                    element.classList.remove("z-10");
                };
            }
        });
    }

    let options = {
        type: 'carousel',
        perView: 1,
        autoplay: 4800,
        animationDuration: 1800,
        swipeThreshold: 40, //default 80, which is a bit too lazy
        dragThreshold: 60, //default 120, which is a bit too lazy
        gap: 80,
        breakpoints: {
            1024: {
                gap: 10
            },

        }
    }

    const glide = new Glide(gliderRoot, options);


    glide.on('mount.after', function () {
        gliderRoot.classList.add('mounted')
    })

    glide.on('run', (event) => {

        //console.log(event);
        //console.log(glide.index);
        //updateNumbers(glide.index);
        //updateBar(glide.index);
        //updateFaces(glide.index);
        updateTexts(texts, glide.index);
        updateTexts(mobileTexts, glide.index);
    })

    glide.mount()

}

export { initHomeHeroGlide }
